var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",attrs:{"href":_vm.link.url ? _vm.link.url : _vm.link,"target":_vm.link.target ? _vm.link.target : _vm.target}},[_vm._v(_vm._s(_vm.link.title ? _vm.link.title : _vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/signs.stagingwebsite.dev/web/app/themes/signs/node_modules/vue-loader/lib?{}!./scripts/vue/PrimaryButton.vue?vue&type=template&id=27f519b4&scoped=true&
// module id = 258
// module chunks = 0